import React, { useState } from "react";
import "./portfolio.css";
import portfolioWebsitePreview from "../../assets/images/portfolio-website-preview.png";
import rawDataGeneratorPreview from "../../assets/images/raw-data-generator-preview.png";
import openSourceContributionsPreview from "../../assets/images/open-source-contributions-preview.png";
import backendDevelopmentPreview from "../../assets/images/backend-development-preview.png"; // Add your new image import

const Portfolio = () => {
    const [toggleState, setToggleState] = useState(false);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <section className="portfolio section" id="portfolio">
            <h2 className="section_title">Portfolio</h2>
            <div className="section_sub">
                <span>A showcase of my completed projects</span>
            </div>

            <div className="portfolio_container container grid">
                {/* Portfolio Website Section */}
                <div className='portfolio_content'>
                    <div>
                        <img src={portfolioWebsitePreview} alt="Portfolio Website Preview" className="portfolio_preview" />
                        <i className='portfolio_icon'>
                            <i class='bx bxl-react'></i>
                            <i class='bx bxl-javascript'></i>
                            <i class='bx bxl-nodejs'></i>
                        </i>
                        <h3 className="project_title">Portfolio Website</h3>
                    </div>
                    <span className="portfolio_button" onClick={() => toggleTab(0)}>View More<i className="uil uil-arrow-right portfolio_button-icon"></i></span>
                    <div className={toggleState === 0 ? "portfolio_modal active_modal" : "portfolio_modal"}>
                        <div className="portfolio_modal-content">
                            <svg onClick={() => toggleTab(false)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M18 6L6 18M6 6l12 12"/></svg>
                            <h3 className="portfolio_modal-title">Personal Project</h3>
                            <p className="portfolio_modal-desc">My personal portfolio website</p>
                            <ul className="portfolio_modal-portfolio grid">  
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        ~ Built using React.js & Node.js
                                    </p>
                                </li>
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info"><a href="#Home" className="project_link" target="_blank" rel="noreferrer">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i>
                                        ~ GitHub Link
                                    </a></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Raw Data Generator Section */}
                <div className='portfolio_content'>
                    <div>
                        <img src={rawDataGeneratorPreview} alt="Raw Data Generator Preview" className="portfolio_preview" />
                        <i className='uil uil portfolio_icon'>
                            <i class='bx bxl-nodejs'></i>
                            <i class='bx bxl-react'></i>
                            <i class='bx bxl-typescript'></i>
                            <i class='bx bxl-github'></i>
                        </i>
                        <h3 className="project_title">Raw Data Generator</h3>
                    </div>
                    <span className="portfolio_button" onClick={() => toggleTab(1)}>View More<i className="uil uil-arrow-right portfolio_button-icon"></i></span>
                    <div className={toggleState === 1 ? "portfolio_modal active_modal" : "portfolio_modal"}>
                        <div className="portfolio_modal-content">
                            <svg onClick={() => toggleTab(false)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M18 6L6 18M6 6l12 12"/></svg>
                            <h3 className="portfolio_modal-title">Frontend and API Integrations</h3>
                            <p className="portfolio_modal-desc">Developed frontend and integrated APIs</p>
                            <ul className="portfolio_modal-portfolio grid">
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i>
                                        ~ A web application to help generate raw data for education and data science purposes
                                    </p>
                                </li>
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        ~ Built using Svelte, TypeScript, TailwindCSS & Flowbit-Svelte Library
                                    </p>
                                </li>
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <a href="https://github.com/Shantanuz06/faker-app" className="project_link" target="_blank" rel="noreferrer">
                                            <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                            ~ GitHub Link
                                        </a>
                                    </p>
                                </li>
                                <li className="portfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <a href="https://fakerop.netlify.app/" className="project_link" target="_blank" rel="noreferrer">
                                            <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                            ~ Project Link
                                        </a>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Open Source Contributions Section */}
                <div className='portfolio_content'>
                    <div>
                        <img src={openSourceContributionsPreview} alt="Open Source Contributions Preview" className="portfolio_preview" />
                        <i className='uil uil portfolio_icon'>
                            <i class='bx bxl-react'></i>
                            <i class='bx bxl-tailwind-css'></i>
                            <i class='bx bxl-graphql'></i>
                        </i>
                        <h3 className="project_title">Open Source Contributions</h3>
                    </div>
                    <span className="portfolio_button" onClick={() => toggleTab(2)}>View More<i className="uil uil-arrow-right portfolio_button-icon"></i></span>
                    <div className={toggleState === 2 ? "portfolio_modal active_modal" : "portfolio_modal"}>
                        <div className="portfolio_modal-content">
                            <svg onClick={() => toggleTab(false)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M18 6L6 18M6 6l12 12"/></svg>
                            <h3 className="portfolio_modal-title">Open Source Contributions</h3>
                            <p className="portfolio_modal-desc">Contributions to various open-source projects.</p>
                            <ul className="portfolio_modal-portfolio grid">
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        ~ Technologies: Java, Spring Boot, Node.js, Svelte, TypeScript, TailwindCSS, GraphQL, SvelteKit
                                    </p>
                                </li>
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        <a href="https://github.com/Syntax-19/devstar/graphs/contributors" className="project_link" target="_blank" rel="noreferrer">
                                        ~ GitHub Link</a>
                                    </p>
                                </li>
                                <li className="portfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <a href="https://developerstar.com/random-data-generator" className="project_link" target="_blank" rel="noreferrer">
                                            <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                            ~ Project Link
                                        </a>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Backend Development Section */}
                <div className='portfolio_content'>
                    <div>
                        <img src={backendDevelopmentPreview} alt="Backend Development Preview" className="portfolio_preview" />
                        <i className='uil uil portfolio_icon'>
                            <i class='bx bxl-java'></i>
                            <i class='bx bxl-spring'></i>
                            <i class='bx bxl-nodejs'></i>
                        </i>
                        <h3 className="project_title">Backend Development</h3>
                    </div>
                    <span className="portfolio_button" onClick={() => toggleTab(3)}>View More<i className="uil uil-arrow-right portfolio_button-icon"></i></span>
                    <div className={toggleState === 3 ? "portfolio_modal active_modal" : "portfolio_modal"}>
                        <div className="portfolio_modal-content">
                            <svg onClick={() => toggleTab(false)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M18 6L6 18M6 6l12 12"/></svg>
                            <h3 className="portfolio_modal-title">Backend Development</h3>
                            <p className="portfolio_modal-desc">Developed RESTful APIs and microservices.</p>
                            <ul className="portfolio_modal-portfolio grid">
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        ~ Technologies: Java, Spring Boot, Node.js
                                    </p>
                                </li>
                                <li className="porfolio_modal-project">
                                    <p className="portfolio_modal-info">
                                        <i className="uil uil-check-circle portfolio_modal-icon"></i> 
                                        <a href="https://github.com/shantanuz06" className="project_link" target="_blank" rel="noreferrer">
                                        ~ GitHub Link</a>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Portfolio;
